function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import { TrackingModule, createInstance } from "@pns-fe/monitor";
import { SDK_BID, VERSION } from "../../constants/env";
import { createSlardarClientAndInit } from "../../utils/SlardarUtil";
import { createTeaAndInit } from "../../utils/TeaUtil";
class MonitorModule {
  constructor(useSingleton) {
    this._tea = null;
    this._slardar = null;
    this._useSingleton = false;
    this._isInitialized = false;
    this.init = (config, sdkContext) => {
      if (this._isInitialized) {
        return;
      }
      this._isInitialized = true;
      const { bid = SDK_BID, version = VERSION, appId, appVersion, tenant } = sdkContext !== null && sdkContext !== void 0 ? sdkContext : {};
      this._name = `${bid}_${version}_${Date.now()}`;
      this._trackingModule = this._useSingleton ? TrackingModule : createInstance(this._name);
      this._tea = createTeaAndInit(config, sdkContext);
      this._teaEventNameFormatter = config === null || config === void 0 ? void 0 : config.teaEventNameFormatter;
      this._slardar = createSlardarClientAndInit(config, sdkContext);
      if (this._slardar) {
        this._trackingModule.init({
          slardarContainer: this._slardar,
          shouldReportJSError: {
            cuj: true
          },
          shouldRegisterUserDrop: false,
          context: {
            appId,
            appVersion,
            tenant
          }
        });
      }
    };
    this.reportCUJ = (name, status, data) => {
      if (!name) {
        return;
      }
      try {
        this._trackingModule.reportCUJ(name, status, data);
        if (this._tea) {
          var _this__teaEventNameFormatter, _this;
          var _this__teaEventNameFormatter1;
          this._tea.event((_this__teaEventNameFormatter1 = (_this__teaEventNameFormatter = (_this = this)._teaEventNameFormatter) === null || _this__teaEventNameFormatter === void 0 ? void 0 : _this__teaEventNameFormatter.call(_this, name)) !== null && _this__teaEventNameFormatter1 !== void 0 ? _this__teaEventNameFormatter1 : name, _object_spread({
            status
          }, data !== null && data !== void 0 ? data : {}));
        }
      } catch (e) {
      }
    };
    this._useSingleton = useSingleton !== null && useSingleton !== void 0 ? useSingleton : false;
  }
}
var MonitorModule_default = MonitorModule;
export {
  MonitorModule_default as default
};

//# sourceMappingURL=MonitorModule.js.map